import PHPInstall from "../../../../contents/docs/integrate/_snippets/install-php.mdx";
import PHPSendEvents from "../../../../contents/docs/integrate/send-events/_snippets/send-events-php.mdx";
import FeatureFlagsLibsIntro from "../../../../contents/docs/libraries/_snippets/feature-flags-libs-intro.mdx";
import PHPFeatureFlagsCode from "../../../../contents/docs/integrate/feature-flags-code/_snippets/feature-flags-code-php.mdx";
import LocalEvaluationIntro from "../../../../contents/docs/feature-flags/snippets/local-evaluation-intro.mdx";
import * as React from 'react';
export default {
  PHPInstall,
  PHPSendEvents,
  FeatureFlagsLibsIntro,
  PHPFeatureFlagsCode,
  LocalEvaluationIntro,
  React
};